import React from 'react';
import './vertical-progress-bar.css';

interface Stage {
    icon: string;
    label: string;
    value: number;
}

interface VerticalProgressBarProps {
    stages: Stage[];
    currentValue: number;
}

const VerticalProgressBar: React.FC<VerticalProgressBarProps> = ({ stages, currentValue }) => {
    return (
        <div className="progress-bar-container">
            <div className="vertical-progress-bar">
                {stages.map((stage, index) => (
                    <div key={index} className="stage-container">
                        <div className="stage-line">
                            {index < stages.length && (
                                <div
                                    className={`line ${stages[index].value <= currentValue ? 'active' : ''
                                        }`}
                                />
                            )}
                        </div>

                        <div
                            className={`stage-icon ${stage.value <= currentValue ? 'completed' : ''
                                }`}
                        >
                            <img id={stage.label} src={stage.icon} alt={stage.label} className="icon-image" />
                        </div>

                        <div className="stage-value">{stage.value}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default VerticalProgressBar;
